import { apiFetch } from '../../services/http';
import type { BootstrapPayload, Session, User } from '../../types/auth';

export type LoginPayload = {
  email: string;
  password: string;
};

export const authApi = {
  login: (payload: LoginPayload) =>
    apiFetch<Session>('/v1/app/login', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    }),
  forgotPassword: (payload: { identifier: string }) =>
    apiFetch<{ message?: string }>('/v1/app/forgot-password', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    }),
  resetPassword: (payload: { token: string; password: string }) =>
    apiFetch<{ ok?: boolean }>('/v1/app/reset-password', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ token: payload.token, newPassword: payload.password }),
    }),
  logout: () =>
    apiFetch<{ ok?: boolean }>('/v1/app/logout', {
      method: 'POST',
    }),
  me: (token: string, init?: RequestInit) =>
    apiFetch<{ user: User; memberships: any[] }>('/v1/app/me', {
      ...init,
      headers: { ...init?.headers, authorization: `Bearer ${token}` },
    }),
  bootstrap: (token: string, init?: RequestInit) =>
    apiFetch<BootstrapPayload>('/v1/app/bootstrap', {
      ...init,
      headers: { ...init?.headers, authorization: `Bearer ${token}` },
    }),
  tenantInfo: (domain: string, tenantId?: string) =>
    apiFetch<import('../../types/auth').TenantInfo>(
      `/v1/app/tenant-info?domain=${encodeURIComponent(domain)}${tenantId ? `&tenant_id=${encodeURIComponent(tenantId)}` : ''}`
    ),
};
